"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const employee_service_1 = require("./employee.service");
const employee_controller_1 = require("./employee.controller");
const typeorm_1 = require("@nestjs/typeorm");
const employee_entity_1 = require("../../../../service-lib/src/lib/entities/employee.entity");
const employee_repository_1 = require("./employee.repository");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const auth_guard_1 = require("../../../../../services/auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../../services/auth-service/src/guards/role.guard");
const jwt_1 = require("@nestjs/jwt");
const environment_1 = require("../../../../service-lib/src/lib/environment");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const notification_utils_1 = require("../../../../service-lib/src/lib/utils/notification.utils");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const entities_1 = require("../../../../service-lib/src/lib/entities");
let EmployeeModule = class EmployeeModule {
};
exports.EmployeeModule = EmployeeModule;
exports.EmployeeModule = EmployeeModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([employee_entity_1.Employee, entities_1.LookUp]),
            jwt_1.JwtModule.register({ secret: environment_1.ENV.JWT_SECRET }),
        ],
        controllers: [employee_controller_1.EmployeeController],
        providers: [
            employee_service_1.EmployeeService,
            employee_repository_1.EmployeeRepository,
            entity_service_utils_1.EntityService,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
            notification_utils_1.NotificationUtils,
        ],
        exports: [employee_service_1.EmployeeService, employee_repository_1.EmployeeRepository],
    })
], EmployeeModule);
